<div class="center-container">
    <h2 class="message-heading">Access Denied</h2>
    <p class="message-content">You don't have access to this page</p>
    <button mat-flat-button color="primary" (click)="GotoDashboard()" >Go to Dashboard</button>
  </div>